import React from 'react';

import AtlaskitAvatar from '@atlaskit/avatar';

export interface UserAvatarProps {
	src?: string | null;
	name: string;
	size?: 'small' | 'medium' | 'large';
}

/**
 * Internal component that renders the user avatar.
 */
function Avatar({ src, name, size = 'medium' }: UserAvatarProps) {
	return <AtlaskitAvatar src={src ?? undefined} name={name} size={size} />;
}

export { Avatar };
